import styled from 'styled-components'

export const Root = styled.div`
  flex-grow: 1;
  z-index: 1;
  overflow: hidden;
  position: relative;
  display: flex;

  a {
    color: inherit;
    text-decoration: none;
  }
`

export const Main = styled.div`
  flex-grow: 1;
  max-width: 100%;

  /*
    this is temporary and just so my eyes don't start bleeding
    looking at that content placeholder
  */
  h1 {
    font-family: 'Roboto', sans-serif;
    font-weight: normal;
    margin: 0;
    text-transform: capitalize;
  }
`



// WEBPACK FOOTER //
// ./src/components/templates/AppLayout.ts